/**
 * Created by bas on 08.12.16.
 * Tizen device info getter
 */


'use strict';

// public
module.exports = {
    getTizenVersion: function () {
        var result;

        try {
            result = window.top.tizen.application.getAppInfo().version;
        } catch ( error ) {
            debug.log('error' + error);
            result = '';
        }

        return result;
    },
    getTvVersion: function () {
        var result;

        try {
            result = window.top.webapis.productinfo.getRealModel();
        } catch ( error ) {
            debug.log('error' + error);
            result = '';
        }

        return result;
    },
    getDeviceMac: function () {
        var result;

        try {
            result = window.top.webapis.network.getMac();
        } catch ( error ) {
            debug.log('error' + error);
            result = '';
        }

        return result;
    }
};
